
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import "firebase/firestore";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyD9a_TGTC8smlNwpnC-BgEq59WQbV74INE",
  authDomain: "siddheswari-bastralaya.firebaseapp.com",
  projectId: "siddheswari-bastralaya",
  storageBucket: "siddheswari-bastralaya.firebasestorage.app",
  messagingSenderId: "474255382987",
  appId: "1:474255382987:web:ffbec41929bad4eb67be4e",
  measurementId: "G-L39PXZ615E"
 
};


const app = initializeApp(firebaseConfig);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const db = getFirestore(app);




export default app;